const CONSTS = {
  objectTypeId: 0,
  storageTypeId: 1,
  projectTypeId: 2,
  packingListTypeId: 3,
  emptyStorageName: "DIVERS",
  emptyProjectName: "DIVERS"
}

export default CONSTS